package com.milta.core.localization.translations.pl

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Zespół",
    sectionLabel = "Połączone organizacje",
    connectedSince = "Połączony od",
    statusActive = "Aktywne",
    statusBroken = "Połączenie przerwane",
    brokenMessage = "Ta organizacja nie jest już dostępna. Nie otrzymasz już od niej tras. Twoje konto Kierowcy pozostaje aktywne.",
    dismissBroken = "Ukryj tę organizację",
    emptyHint = "Nie jesteś połączony z żadną organizacją. Patron może cię dodać za pomocą kodu połączenia (zobacz Profil).",
    errorGeneric = "Wystąpił błąd. Spróbuj ponownie.",
    monthNames = listOf("styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"),
    enterpriseSectionLabel = "Kierowcy zespołu",
    enterpriseEmptyHint = "W Twoim zespole nie ma jeszcze żadnych kierowców.",
    noEnterpriseFound = "Brak firmy powiązanej z Twoim kontem.",
    columnHeaderDriver = "Kierowca",
    columnHeaderStatus = "Status",
    columnHeaderActions = "Akcje",
    addDriverSectionTitle = "Dodaj kierowcę",
    addDriverCodePlaceholder = "Kod Milta — np. MTA-28371",
    addDriverButton = "Dodaj tego kierowcę",
    addDriverErrorInvalidCode = "Wprowadź prawidłowy kod.",
    addDriverErrorNotFound = "Nieprawidłowy lub już wykorzystany kod.",
    addDriverErrorAlreadyMember = "Ten kierowca jest już częścią Twojego zespołu.",
    addDriverErrorLinkedAccountIsEnterprise = "To konto jest firmą i nie może zostać dodane jako kierowca.",
    driverDetailTitle = "Dane kierowcy",
    driverDetailPhoneLabel = "Telefon",
    removeDriverButton = "Usuń",
    removeDriverDialogTitle = "Usunąć tego kierowcę?",
    removeDriverDialogMessagePrefix = "Zamierzasz usunąć",
    removeDriverDialogMessageSuffix = "z Twojego zespołu. Jego/jej konto Milta pozostanie aktywne.",
    removeDriverErrorNotFound = "Nie znaleziono kierowcy.",
    removeDriverErrorOnActiveDelivery = "Ten kierowca realizuje obecnie aktywną dostawę i nie można go usunąć.",
    removeDriverErrorLastOwner = "Jesteś jedynym menedżerem tej firmy. Dodaj inne konto Firmy przed usunięciem siebie z zespołu.",
)
